/* eslint-disable  import/prefer-default-export, @typescript-eslint/no-unsafe-return */

import { ReactElement, useContext } from 'react';
import CustomComponentContext from '../../CustomComponentContext';

import ja from '../translations/locales/ja.json';

import metro from '../translations/carriers/metro.json';
import sagawaV2 from '../translations/carriers/sagawa-v2';

const langMap: Record<string, Record<string, any>> = {
  ja,
};

const carrierMap: Record<string, Record<string, any>> = {
  metro,
  'sagawa-v2': sagawaV2,
};

const translateLang = (mainKey: string) => {
  const map = langMap[mainKey] ?? {};
  return (key: string, defValue: string = key): string => {
    let v = map[key];
    if (typeof v === 'undefined' && key.substring(key.length - 1) === '.') {
      const newKey = key.substring(0, key.length - 1);
      v = map[newKey];
    }
    return v ?? defValue;
  };
};

const translateForCarrier = (mainKey: string) => {
  const map = carrierMap[mainKey] ?? {};
  return (key: string, defValue = undefined): ReactElement => {
    const v = map[key];
    return (v ?? (defValue as unknown)) as ReactElement;
  };
};

export const useTranslator = () => {
  const { state } = useContext(CustomComponentContext);
  const { localeLanguage = '', carrier = '' } = state.pageContext;

  const t = translateLang(localeLanguage);
  const tc = translateForCarrier(carrier);
  return { t, tc, locale: localeLanguage };
};
